import {
	sha as commitId,
	abbreviatedSha as commitIdShort,
	github as gitUrl
} from "~build/git";
import invariant from "tiny-invariant";

import type { DevicePlatform } from "./hooks/use-device";

export { default as builtAt } from "~build/time";

export const siteOrigin = import.meta.env.VITE_ORIGIN as string;
invariant(siteOrigin, "VITE_ORIGIN is required");

export const shortOrigin = import.meta.env.VITE_SHORT_ORIGIN as string || siteOrigin;
export const shortHost = new URL(shortOrigin).host;

export const deepLinkOrigins = [
	shortOrigin,
	...(import.meta.env.VITE_DEEP_LINK_ORIGINS as string || "").split(",").filter(Boolean)
];

export const apiUrl = import.meta.env.VITE_API_URL as string;
invariant(apiUrl, "VITE_API_URL is required");

export const apiOrigin = new URL(apiUrl).origin;

export const appBundleId = import.meta.env.VITE_APP_BUNDLE_ID as string;
export const appStoreId = import.meta.env.VITE_APP_STORE_ID as string || undefined;

export const preview = import.meta.env.VITE_PREVIEW as string || null;
export const development = import.meta.env.DEV;
export const production = !development;

// Captcha
export const turnstileSiteKey = import.meta.env.VITE_TURNSTILE_SITE_KEY as string;
export const talkjsAppId = import.meta.env.VITE_TALKJS_APP_ID as string;

// Sentry
export const sentryDsn = import.meta.env.VITE_SENTRY_DSN as string;
export const sentryOrganization = import.meta.env.VITE_SENTRY_ORGANIZATION as string;
export const sentryProjectId = Number.parseInt(import.meta.env.VITE_SENTRY_PROJECT_ID as string || "0");
export const sentryReportTo = import.meta.env.VITE_SENTRY_REPORT_TO as string | undefined;
export const sentryTraces = Number.parseFloat(
	import.meta.env.VITE_SENTRY_TRACES as string || (production ? "0.1" : "0")
);
export const sentryProfiles = Number.parseFloat(
	import.meta.env.VITE_SENTRY_PROFILES as string || (production ? "1" : "0")
);

// PostHog
export const posthogKey = import.meta.env.VITE_POSTHOG_KEY as string;
export const posthogHost = import.meta.env.VITE_POSTHOG_HOST as string;
export const posthogUiHost = import.meta.env.VITE_POSTHOG_UI_HOST as string || "https://us.posthog.com";

// Miscellaneous
export const freshworksWidgetId = import.meta.env.VITE_FRESHWORKS_WIDGET_ID as string;

export const chargebeeNamespace = import.meta.env.VITE_CHARGEBEE_NAMESPACE as string;
export const rcAppleKey = import.meta.env.VITE_RC_APPL_PUBLIC_KEY as string;
export const rcGoogleKey = import.meta.env.VITE_RC_GOOG_PUBLIC_KEY as string;
export const rcProjectId = import.meta.env.VITE_RC_PROJECT_ID as string;
export const picoAppId = import.meta.env.VITE_PICO_APP_ID as string;

export const appleSigninServiceId = import.meta.env.VITE_APPLE_SIGNIN_SERVICE_ID as string;
export const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID as string;
export const googleIosClientId = import.meta.env.VITE_GOOGLE_IOS_CLIENT_ID as string;

export const bucketContentOrigin = (import.meta.env.VITE_BUCKET_CONTENT_ORIGIN as string) || "";
export const bucketUploadsOrigin = (import.meta.env.VITE_BUCKET_UPLOADS_ORIGIN as string) || "";

export const region = import.meta.env.VERCEL_REGION as string;

export const platformOverride = import.meta.env.VITE_PLATFORM_OVERRIDE as DevicePlatform | undefined;
export const nativeOverride = platformOverride ? platformOverride !== "web" : undefined;

export const maintenance = false;
export const server = import.meta.env.SSR;
export const client = !server;

export { commitId, commitIdShort };

export const commitUrl = `${gitUrl}/commit/${commitId}`;

// Like "2026.10.30-beta.1+656d3d3", from the Version resource in the pulumi submodule
// (src/resources/version.ts).
export const version = import.meta.env.VITE_RELEASE_NAME as string || commitId.slice(0, 7);
